const _subsidyFilesSelector = state => state.app.subsidyFiles

export const subsidyFilesSelector = state => _subsidyFilesSelector(state).value
export const subsidyFilesLoadingSelector = state => _subsidyFilesSelector(state).loading
export const subsidyFilesErrorSelector = state => _subsidyFilesSelector(state).error

